import React from 'react';
import { Link } from 'react-router-dom';

const HomeHeroSection = () => {
  return (
    <section aria-labelledby="hero-title" className="site-bg-hero text-center py-20 px-6">
      <h1 id="hero-title" className="text-5xl font-bold tracking-tight text-gray-900 sm:text-6xl">
        Guilherme Portella
      </h1>
      <p className="mt-6 text-lg leading-8 text-gray-600">
        BackEnd Developer | Tech Enthusiast | Lifelong Learner
      </p>
      <div className="mt-10 flex items-center justify-center gap-x-6">
        <Link
          to="/projects"
          className="rounded-md bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
        >
          View My Work
        </Link>
        <a href="#contato" className="text-sm font-semibold leading-6 text-gray-900">
          Entre em contato <span aria-hidden="true">&rarr;</span>
        </a>
      </div>
    </section>
  );
};

export default HomeHeroSection;
